import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-MV5GN7J4",
};

export const initializeGTM = () => {
  TagManager.initialize(tagManagerArgs);
};

export const trackSubCategoryView = (id: string, name: string) => {
  TagManager.dataLayer({
    dataLayer: {
      event: "sub_category_viewed",
      sub_category_id: id,
      sub_category_name: name,
    },
    dataLayerName: "sub_category_viewed",
  });
};
